import { environment } from '../../environments/environment';
export const baseAPIUrl = environment.API_URL;
export const clientId = environment.CLIENT_ID || '';
export const clientSecret = environment.CLIENT_SECRET || '';

export interface DateRange {
  fromDate: Date;
  toDate: Date;
}

export const dateRangeButtons = [
  '1W',
  '1M',
  '3M',
  'LM',
  'MTD',
  'YTD',
  '1Y',
  'All',
];
